/* External */
import { makeFetchActionTypes, makeFetchActionCreators } from "../../utils";

export const baseActionName = "homeTab";
export const actionTypes = makeFetchActionTypes(baseActionName);
const actionCreators = makeFetchActionCreators(baseActionName);
export const { fetch: fetchHomeTab, reset: resetHomeTab } = actionCreators;
